import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import styles from 'components/star/Star.module.scss';
import {Context} from "context";

export default function Star(props) {
    const context = useContext(Context);

    const handleClick = () => {
        props.onClick();
    }

    return (
        <div className={`${styles.star} star`} data-hint={context.text.hints.star} onMouseDown={event => event.stopPropagation()}>
            {props.modified ?
                <img
                    src={require(`images/icons/tick.svg`)}
                    alt="Edited"
                    title="Edited"
                />
            :
                <img
                    src={require(`images/icons/star-${props.favourited ? "" : "empty-"}${context.lightTheme ? "light" : "dark"}.svg`)}
                    alt={props.favourited ? "Favourited" : "Not Favourited"}
                    title={props.favourited ? "Favourited" : "Not Favourited"}
                    onClick={handleClick}
                    className={props.favourited ? null : styles.empty}
                />
            }
        </div>
    );
}

Star.propTypes = {
    favourited: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    modified: PropTypes.bool.isRequired
};